import { observer } from 'mobx-react-lite';
import TableComponent from './TableComponent';
import { useStore } from '../../../app/stores/store';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import UnauthorizedMessage from '../../UnauthorizedMessage';

const TitleWiseProductionHoursReport = () => {
  const { RestorationStore, dashboardStore, commonStore } = useStore();
  const dateBasedApiCall = async (fromDate?: string, toDate?: string) => {
    await RestorationStore.HandelTaskWiseOverAllTitle(
      fromDate || '',
      toDate || '',
    );
  };
  return (
    <div>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('TWPHR01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne?.includes('TWPHR01') && (
        <TableComponent
          name={'Title-Wise Production Hours Report'}
          dateBasedApiCall={dateBasedApiCall}
          DateInput={true}
          DualInut={false}
          downloadName={'Title-Wise Production Hours Report'}
        />
      )}
    </div>
  );
};

export default observer(TitleWiseProductionHoursReport);
